import { Button, DatePicker, Form, Grid, Input, Select } from "antd";
import { ContentFilters } from "components";
import { StandardItemsWrapper } from "components/content-filters/content-filters.styles";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DATE_FORMATS } from "utils/date";

import {
  DiscountCodeFilterFormField,
  DiscountCodeFilterFormValues,
} from "./type";

const { useBreakpoint } = Grid;

type UsersWithWalletFilterFormProps = {
  formId: string;
  handleFilter: (values: DiscountCodeFilterFormValues) => void;
  initialValues: DiscountCodeFilterFormValues;
  closeModal?: () => void;
  form: any;
};

export const DiscountCodeFilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
  form,
}: UsersWithWalletFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(["onSubmit"]);
  // const [form] = Form.useForm<DiscountCodeFilterFormValues>();
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const { RangePicker } = DatePicker;

  const onReset = () => {
    form.resetFields();
    handleFilter({ ...initialValues });
  };

  const handleOnFinish = (values: DiscountCodeFilterFormValues) => {
    handleFilter(values);
    // setQueryFilters(values);
    closeModal?.();
  };

  return (
    <>
      <div className="notify_form">
        <Form<DiscountCodeFilterFormValues>
          id={formId}
          name={formId}
          form={form}
          layout="vertical"
          onFinish={handleOnFinish}
          initialValues={initialValues}
          onFinishFailed={() => {
            setValidateTrigger(["onChange"]);
          }}
          validateTrigger={validateTrigger}
        >
          <ContentFilters.FormItemsWrapper>
            <StandardItemsWrapper>
              <Form.Item<DiscountCodeFilterFormValues>
                label={"Title"}
                name={DiscountCodeFilterFormField.title}
              >
                <Input placeholder="Search By the discount code and facility name" />
              </Form.Item>

              <Form.Item<DiscountCodeFilterFormValues>
                label={"Type"}
                name={DiscountCodeFilterFormField.DiscountCodetypeid}
              >
                <Select
                  style={{ width: 150 }}
                  options={[
                    { value: "1", label: "Flat" },
                    { value: "2", label: "Percentage" },
                  ]}
                  placeholder="Select Type"
                />
              </Form.Item>
              <Form.Item
                label="Coupon For"
                name="CouponFor"
                rules={[
                  { required: true, message: "Please select Coupon For" },
                ]}
              >
                <Select
                  allowClear
                  placeholder="Please select Discount For"
                  options={[
                    { value: "Booking", label: "Booking" },
                    { value: "Package", label: "Package" },
                    { value: "FixedBooking", label: "Fixed Booking" },
                  ]}
                />
              </Form.Item>

              <Form.Item<DiscountCodeFilterFormValues>
                label={"Date"}
                name={DiscountCodeFilterFormField.Date}
              >
                <RangePicker
                  allowEmpty={[true, true]}
                  format={DATE_FORMATS.date}
                />
              </Form.Item>

              <Form.Item<DiscountCodeFilterFormValues>
                label={"Status"}
                name={DiscountCodeFilterFormField.status}
              >
                <Select
                  style={{ width: 120 }}
                  options={[
                    { value: true, label: "Active" },
                    { value: false, label: "InActive" },
                  ]}
                  placeholder="Select Status"
                />
              </Form.Item>
            </StandardItemsWrapper>
          </ContentFilters.FormItemsWrapper>

          {screens.lg && (
            <ContentFilters.ButtonsWrapper>
              <Button type="primary" htmlType="submit">
                {t("wallet.buttons.filter", { count: 1 })}
              </Button>
              <Button onClick={onReset}>{t("wallet.buttons.reset")}</Button>
            </ContentFilters.ButtonsWrapper>
          )}
        </Form>
      </div>
    </>
  );
};
